/*** IMPORTS FROM imports-loader ***/
(function() {

define([], function(){

        var events = {
            shippingOptions: {
                checkZipSuccess: {
                    eventInfo: {
                        eventName: 'check fulfillment availability'
                    },
                    category: {
                        primaryCategory: 'button submission'
                    },
                    item: [{
                        productInfo: {
                            sku: 0,
                        },
                        fulfillment: {
                            method : 'STH'
                        }
                    }]
                },
                checkZipError: {
                    eventInfo: {
                        eventName: 'error',
                        errorMessage: 'please enter a valid zip code',
                        errorType: 'deta'
                    },
                    category: {
                        primaryCategory: 'error'
                    }
                }
            },
            overlays: {
                expandMediaView: {
                    eventName: 'expanded view'
                },
                expressDeliveryOverlayLinkClicked: {
                    eventName: 'view delivery faqs'
                },
                ecorebatesLinkClicked: {
                    eventName: 'mail in rebate'
                },
                ecorebatesOverlayLinkClicked: {
                  eventName: 'available rebates'
                }
            }
        };

        var errorStates = {
            fulfillment: {
                store: {
                    isLimitedQuantity: {
                        message: "limited quantity; check inventory at other stores",
                        type: 'error',
                        displayType: 'inline',
                        pageSection: 'pip'
                    },
                    isOutOfStock: {
                        message: "0 in stock; check inventory at other stores",
                        type: 'error',
                        displayType: 'inline',
                        pageSection: 'pip'
                    },
                    isAlphaPromptRestricted: {
                        message: "alphaprompt: at this location, the item must be purchased in-store",
                        type: 'error',
                        displayType: 'inline',
                        pageSection: 'pip'
                    }
                },
                appliance: {
                    oos_eta_unavail: {
                        message: 'Out of stock',
                        type: 'error',
                        displayType: 'inline',
                        pageSection: 'appliance pip',
                        code: 'oos_eta_unavail'
                    },
                    oos_altmodel: {
                        message: 'Out of stock',
                        type: 'error',
                        displayType: 'inline',
                        pageSection: 'appliance pip',
                        code: 'oos_altmodel'
                    },
                    unavailable: {
                        message: 'We\'re sorry. Appliance delivery isn\'t offered to your area. ' +
                        'Your nearest store may be able to offer other arrangements.',
                        type: 'error',
                        displayType: 'inline',
                        pageSection: 'appliance pip',
                        code: 'unavailable'
                    },
                    unavail_zipcode: {
                        message: 'We\'re sorry. Appliance delivery isn\'t offered to your area. ' +
                        'Your nearest store may be able to offer other arrangements.',
                        type: 'error',
                        displayType: 'inline',
                        pageSection: 'appliance pip',
                        code: 'unavail_zipcode'
                    },
                    unavail_primarystore: {
                        message: 'We\'re sorry. Appliance delivery isn\'t offered to your area. ' +
                        'Your nearest store may be able to offer other arrangements.',
                        type: 'error',
                        displayType: 'inline',
                        pageSection: 'appliance pip',
                        code: 'unavail_primarystore'
                    },
                    nomatch_cartzipcode: {
                        message: 'All major appliances must be delivered to the same address. ' +
                        'To change the delivery ZIP code for appliances in your cart, ' +
                        'please first remove the items from your cart, then re-add ' +
                        'them with your updated ZIP code.',
                        type: 'error',
                        displayType: 'inline',
                        pageSection: 'appliance pip',
                        code: 'nomatch_cartzipcode'
                    },
                    available_service_exception: {
                        message: 'This item is unavailable for delivery in the next 90 days. ' +
                        'Your local store is unable to deliver the requested item.',
                        type: 'error',
                        displayType: 'inline',
                        pageSection: 'appliance pip',
                        code: 'available_service_exception'
                    },
                    generic_error: {
                        message: "We're sorry. An error occurred.",
                        type: 'system',
                        displayType: 'inline',
                        pageSection: 'appliance pip',
                        code: 'generic_error'
                    }
                },
                expressDelivery: {
                    NO_BODFS_STORES:  {
                        message: "Sorry, this item is not available for delivery in this ZIP code. Enter a valid ZIP code or select another fulfillment method.",
                        type: 'error',
                        displayType: 'inline',
                        pageSection: 'bodfs',
                        code: 'NO_BODFS_STORES'
                    },
                    NO_STORES: {
                        message: "Sorry, this item is not available for delivery in this ZIP code. Enter a valid ZIP code or select another fulfillment method.",
                        type: 'error',
                        displayType: 'inline',
                        code: 'NO_STORES'
                    },
                    ITEM_NOT_ASSORTED: {
                        message: "Sorry, this item is not available for delivery in this ZIP code. Enter a valid ZIP code or select another fulfillment method.",
                        type: 'error',
                        displayType: 'inline',
                        code: 'ITEM_NOT_ASSORTED'
                    },
                    ALPHA_PROMPT_RESTRICTION: {
                        message: "Sorry, this item must be purchased in store for this ZIP code.",
                        type: 'error',
                        displayType: 'inline',
                        code: 'ALPHA_PROMPT_RESTRICTION'
                    },
                    INVALID_ZIPCODE: {
                        message: "Sorry, this item is not available for delivery in this ZIP code. Enter a valid ZIP code or select another fulfillment method.",
                        type: 'error',
                        displayType: 'inline',
                        code: 'INVALID_ZIPCODE'
                    },
                    NO_INVENTORY:  {
                        message: "Sorry, this item is not available for delivery in this ZIP code. Enter a valid ZIP code or select another fulfillment method.",
                        type: 'error',
                        displayType: 'inline',
                        pageSection: 'bodfs',
                        code: 'NO_INVENTORY'
                    },
                    NOT_ENOUGH_INVENTORY: {
                        message: "Sorry, not all items are in stock for delivery in this ZIP code. Please update your quantity or select another fulfillment method.",
                        type: 'error',
                        displayType: 'inline',
                        code: 'NOT_ENOUGH_INVENTORY'
                    },
                    INVALID_QUANTITY: {
                        message: "Please enter a valid quantity.",
                        type: 'system',
                        displayType: 'inline',
                        code: 'INVALID_QUANTITY'
                    },
                    NOT_FOUND: {
                        message: "Delivery scheduling is unavailable for this order.",
                        type: 'system',
                        displayType: 'inline',
                        code: 'NOT_FOUND'
                    },
                    NOT_BODFS_ELG: {
                        message: "Delivery scheduling is unavailable for this order.",
                        type: 'system',
                        displayType: 'inline',
                        code: 'NOT_BODFS_ELG'
                    },
                    NO_BODFS_ITEMS: {
                        message: "Delivery scheduling is unavailable for this order.",
                        type: 'system',
                        displayType: 'inline',
                        code: 'NO_BODFS_ITEMS'
                    },
                    ZIPCODE_SERVICE_DOWN: {
                        message: "Delivery scheduling is unavailable. You may still add this item to your cart and complete your order.",
                        type: 'system',
                        displayType: 'inline',
                        code: 'ZIPCODE_SERVICE_DOWN'
                    },
                    PRD_SRCH_ERR_503: {
                        message: "Delivery scheduling is unavailable. You may still add this item to your cart and complete your order.",
                        type: 'system',
                        displayType: 'inline',
                        code: 'PRD_SRCH_ERR_503'
                    },
                    GENERIC_ERROR: {
                        message: "We're sorry. We're currently unable to access scheduling information. Please try again shortly.",
                        type: 'system',
                        displayType: 'inline',
                        code: 'NOT_BODFS_ELG'
                    }
                }
            },
            media: {
                threesixty: {
                    thumbnailDidNotLoad: {
                        message: "threesixty thumbnail did not load",
                        type: 'system',
                        displayType: 'inline',
                        pageSection: 'pip'
                    }
                }
            }
        };

        return {
            errorStates: errorStates,
            events: events
        }
    });

}.call(window));